export const HELP_ANCHOR_ATTRIBUTE = 'data-help-id';

// Naming convention: <feature-or-route>.<stable-semantic-region>.
// Responsive elements that coexist in the DOM must use distinct values.
export const HELP_ANCHORS = Object.freeze({
    NEW_REPORT_DASHBOARD: 'new-report.dashboard-entry',
    NEW_REPORT_NAV_DESKTOP: 'new-report.desktop-nav',
    NEW_REPORT_NAV_MOBILE: 'new-report.mobile-nav',
    INPUT_TEMPLATES: 'report-input.templates',
    INPUT_UPLOAD: 'report-input.upload',
    INPUT_REVIEW: 'report-input.review',
    INPUT_REVIEW_READY: 'report-input.review-ready',
    INPUT_NEXT_STEP: 'report-input.next-step',
    REPORT_SELECTION: 'report-selection.categories',
    REPORT_QUEUE_READY: 'report-selection.queue-ready',
    REPORT_GENERATE: 'report-selection.generate',
});

export const HELP_ANCHOR_VALUES = Object.freeze(Object.values(HELP_ANCHORS));

export const isKnownHelpAnchor = (value) => HELP_ANCHOR_VALUES.includes(value);
